import React from 'react'

import LinkWithQueryForwarding from '../button/LinkWithQueryForwarding'
import GliderClient from '../ClientGlider'
import Icon from '../icons/Icon'

type TestItemProps = {
  readonly testData: {
    readonly slug: string
    readonly slugOverwritten?: string
    readonly iconName: string
    readonly title: string
  }
  readonly isLocked?: boolean
  readonly isPreview: boolean
  readonly className?: string
  readonly baseLink: string
}

const TestItem: React.FC<TestItemProps> = ({ testData, isLocked, isPreview, className, baseLink }) => {
  const slug = testData.slug

  const test = (
    <div className="relative grow rounded-xl bg-white p-6 pb-14 shadow-hedepy">
      {isLocked && (
        <div className="absolute right-6 top-6 z-10 flex shrink rounded-full bg-petrol-500 bg-opacity-100">
          <Icon icon="lock-alt" color="white" size="md" className="m-6" />
        </div>
      )}
      <div className={`${isLocked && 'opacity-40'}`}>
        {testData.iconName && <Icon icon={testData.iconName} size="md" color="primary" className="mb-2" />}

        <h2 className="pb-4 text-xl text-text-color">{testData.title}</h2>
        <div className="absolute inset-x-0 bottom-0">
          <div className="text-right">
            <Icon icon="arrow" size="md" className="m-6" />
          </div>
        </div>
      </div>
    </div>
  )
  if (!isPreview && isLocked) return <>{test}</>

  return (
    <LinkWithQueryForwarding
      href={isLocked ? `${baseLink}` : `${baseLink}/${slug}`}
      key={testData.slug}
      className={`${className} flex self-stretch hover:no-underline`}
    >
      {test}
    </LinkWithQueryForwarding>
  )
}

type Props = {
  readonly data: {
    readonly attributes: {
      readonly slug: string
      readonly slugOverwritten?: string
      readonly iconName: string
      readonly title: string
    }
  }[]
  readonly isPreview?: boolean
  readonly baseLink: string
}

const TestsList: React.FC<Props> = ({ data, isPreview, baseLink }) => {
  const tests = data

  const renderRegularList = () => (
    <div className="grid grid-cols-2 gap-5 tablet:grid-cols-3 desktop:grid-cols-4">
      {tests?.map((item) => {
        const testData = item.attributes

        return <TestItem testData={testData} key={testData.slug} isPreview={isPreview} baseLink={baseLink} />
      })}
    </div>
  )

  const renderGlider = () => (
    <GliderClient className="articles tablet:hidden" draggable slidesToShow={1.5} slidesToScroll={1}>
      {tests?.map((item) => {
        const testData = item.attributes

        return (
          <TestItem
            key={testData.slug}
            testData={testData}
            isPreview={isPreview}
            className="mb-6 mr-4 max-h-[200px] basis-[215px]"
            baseLink={baseLink}
          />
        )
      })}
    </GliderClient>
  )

  if (!tests) return <p>There is no content for this version of language.</p>

  if (isPreview)
    return (
      <>
        <div className="tablet:hidden">{renderGlider()}</div>
        <div className="hidden tablet:block">{renderRegularList()}</div>
      </>
    )

  return renderRegularList()
}

export default TestsList
